import { render, staticRenderFns } from "./ImportPreschoolStudent.vue?vue&type=template&id=8fae6eba&"
import script from "./ImportPreschoolStudent.vue?vue&type=script&lang=js&"
export * from "./ImportPreschoolStudent.vue?vue&type=script&lang=js&"
import style0 from "./ImportPreschoolStudent.vue?vue&type=style&index=0&id=8fae6eba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports